import React from 'react';
import { useForm } from 'react-hook-form';
import FormHook from 'components/form-hook/form-hook';
import { Button, Flex } from 'common/common-components.styled';
import isEmpty from 'lodash/isEmpty';
import { useEditTask } from './use-edit-task';
import { EditTaskProps } from './edit-task.types';
import SpinnerContainer from 'components/spinner-container';

const EditTask = ({
  taskData,
  isUploadDocumentTask,
  documentType,
  saveDocumentTo,
  refresh,
  onCancel
}: EditTaskProps) => {
  const reactHookFormData = useForm();
  const {
    formState: { errors }
  } = reactHookFormData;

  const {
    titleField,
    employeesFormField,
    vehicleFormField,
    filesDescriptionField,
    dueDateField,
    dueDateCalendarField,
    descriptionField,
    filesField,
    saveDocumentToFiled,
    isCalendarVisible,
    isLoading,
    onSubmit
  } = useEditTask({
    reactHookFormData,
    isUploadDocumentTask,
    taskData,
    documentType,
    saveDocumentTo,
    refresh,
    onCancel
  });

  if (isLoading) {
    return <SpinnerContainer minHeight='200px' />;
  }

  return (
    <Flex top='30' direction='column'>
      <FormHook reactHookFormData={reactHookFormData} formFields={titleField} />
      <Flex>
        {!isUploadDocumentTask && <FormHook reactHookFormData={reactHookFormData} formFields={vehicleFormField} />}
        {!isUploadDocumentTask && (
          <FormHook reactHookFormData={reactHookFormData} formFields={employeesFormField} marginLeft='10' />
        )}

        {isUploadDocumentTask && <FormHook reactHookFormData={reactHookFormData} formFields={filesDescriptionField} />}

        <FormHook reactHookFormData={reactHookFormData} formFields={dueDateField} marginLeft='10' />
      </Flex>

      {isUploadDocumentTask && <FormHook reactHookFormData={reactHookFormData} formFields={saveDocumentToFiled} />}
      {isCalendarVisible && <FormHook reactHookFormData={reactHookFormData} formFields={dueDateCalendarField} />}
      <FormHook reactHookFormData={reactHookFormData} formFields={descriptionField} />

      {!isUploadDocumentTask && <FormHook reactHookFormData={reactHookFormData} formFields={filesField} />}

      <Flex justify='flex-end'>
        <Button secondary onClick={onCancel}>
          Abbrechen
        </Button>
        <Button left='10' disabled={!isEmpty(errors)} onClick={onSubmit}>
          Speichern
        </Button>
      </Flex>
    </Flex>
  );
};

export default EditTask;
